export default "__VITE_ASSET__O20notEH__"